/**
 * 验证邮箱
 * @param {*} rule
 * @param {String} value
 * @param {Function} callback
 */
export const email = (rule,value,callback)=>{
  let reg = /^[a-z0-9]+@([a-z0-9]+\.)+[a-z]{2,4}$/i;
  if (!reg.test(value)) {
    callback(new Error('请输入正确邮箱！'))
  } else {
    callback()
  }
}


/**
 * 验证手机号
 * @param {*} rule
 * @param {String} value
 * @param {Function} callback
 */
export const phone = (rule,value,callback)=>{
  let phone1 = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
  let phone2 = /^1(3|4|5|7|8)\d{9}$/;
  if (phone1.test(value) || phone2.test(value)) {
    callback()
  }else{
    callback(new Error('请输入正确电话'))
  }
}
/**
 * 验证用户名
 * @param {*} rule
 * @param {String} value
 * @param {Function} callback
 */
export const name = (rule,value,callback)=>{
  let reg = /[\u4e00-\u9fa5]+/
  if(reg.test(value)){
    callback()
  }else{
    callback(new Error("请输入中文"))
  }
}

/**
 * 验证码
 * @param {*} rule
 * @param {String} value
 * @param {Function} callback
 */
export const verifyCode = (rule,value,callback)=>{
  if(rule.verifyCode && rule.verifyCode==value){
    callback()
  }else{
    callback(new Error("验证码错误"))
  }
}
/**
 * 密码
 * @param {*} rule
 * @param {String} value
 * @param {Function} callback
 */
export const password = (rule,value,callback)=>{
  if(rule.status || rule.mode=='login'){
    callback()
  }else{
    callback(new Error("两次密码不一致"))
  }
}
/**
 * 
 */
export const testPassword = (rule,value,callback)=>{
  // let reg = /(?![0-9]+$)(?![a-z]+$)[a-zA-Z0-9\?\.\_\~\!]{8,16}/
  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
  if(reg.test(value)){
    callback()
  }else{
    callback(new Error("请输入至少包含数子、因文字母两种"))
  }
}


// WEBPACK FOOTER //
// ./src/utils/formValidate.js